export { Heading, HeadingWithCapsize } from './Heading'
/** @deprecated */
export type { HeadingProps, HeadingWithCapsizeProps } from './Heading'
